// Price section minimum height, to prevent layout shifting while loading price or don't have price.
export const PRICE_MIN_HEIGHT = 96;
export const COMPARISON_PRICE_MIN_HEIGHT = 68;

// Image dimensions and aspect ratios
// Keeping it 1.1 to 1 ratio to fit the image in the container without cropping.
export const HORIZONTAL_ASPECT_RATIO = '1.1/1';
export const VERTICAL_ASPECT_RATIO = '3/2';

export const HORIZONTAL_IMAGE_MAX_WIDTH = 370;
export const HORIZONTAL_IMAGE_MAX_HEIGHT = 315;
export const VERTICAL_IMAGE_MAX_HEIGHT = 206;

export const EVENT_PHOTO_SIZE = 40;
